import { DatePipe } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptors,
  withInterceptorsFromDi,
} from '@angular/common/http';
import {
  ApplicationConfig,
  ErrorHandler,
  importProvidersFrom,
  inject,
  LOCALE_ID,
  provideAppInitializer,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import * as Sentry from '@sentry/angular';
import { BackButtonDisableModule } from 'angular-disable-browser-back-button';
import { KeycloakAngularModule, KeycloakService } from 'keycloak-angular';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { NgxFileDropModule } from 'ngx-file-drop';
import { QuillModule } from 'ngx-quill';
import { environment } from 'src/environments/environment';
import { createTranslateLoader } from '@core/config/translate-loader';
import { AppRoutingModule } from './app-routing.module';
import { AuthErrorInterceptor } from '@core/interceptors/add-bearer-token.interceptor';
import { addUserIdInterceptor } from '@core/interceptors/add-userId.interceptor';
import { ServerErrorInterceptor } from '@core/interceptors/server-error.interceptor';
import { CdkTableModule } from '@angular/cdk/table';

function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: environment.odfinKeycloakConfig,
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/assets/silent-check-sso.html',
        scope: 'institutions email gender profile openid',
      },
      enableBearerInterceptor: true,
      bearerPrefix: 'Bearer',
      bearerExcludedUrls: [
        // environment.apiURL + "",
        'https://bankhausbauer.kontowechselservice.de/INTE/SSO.aspx',
      ],
    });
}

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      BackButtonDisableModule.forRoot(),
      KeycloakAngularModule,
      PdfViewerModule,
      BrowserModule,
      AppRoutingModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient],
        },
      }),
      QuillModule.forRoot(),
      FormsModule,
      ReactiveFormsModule,
      NgxFileDropModule
    ),
    provideAppInitializer(() => {
      const init = initializeKeycloak(inject(KeycloakService));
      return init();
    }),
    DatePipe,
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler(),
    },
    { provide: LOCALE_ID, useValue: 'de' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ServerErrorInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi(), withInterceptors([addUserIdInterceptor])),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthErrorInterceptor,
      multi: true,
    },
    provideAnimations(),
  ],
};
